export const HeadlineTypeValues = {
  MAIN_TITLE: 'main-title',
  SUBTITLE: 'sub-title',
  HEADING_1: 'heading-1',
  HEADING_2: 'heading-2',
  HEADING_3: 'heading-3',
  HEADING_4: 'heading-4',
} as const;

export type HeadlineType = (typeof HeadlineTypeValues)[keyof typeof HeadlineTypeValues];

export const HeadlineTagValues = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
} as const;

export type HeadlineTag = (typeof HeadlineTagValues)[keyof typeof HeadlineTagValues];
